import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=a7a1940c&scoped=true"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=a7a1940c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a1940c",
  null
  
)

export default component.exports